export default __webpack_public_path__ + "static/media/Netflix2.7c23fd91.png";